import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "w100 pad40 centered",
  style: {"height":"440px"}
}
const _hoisted_2 = { class: "title mc" }
const _hoisted_3 = {
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "fw400 fs13",
  style: {"margin-top":"40px"}
}
const _hoisted_6 = { class: "fw600 fs14 ddgrey kaigyo" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_9 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_13 = { class: "fs14 whiteColor fw600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_RoomLightOverViewContent = _resolveComponent("RoomLightOverViewContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "CreateFromDraftModal",
    "content-class": "modalContent shadowContent rad10 modalStandard posFi"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.getTitle()), 1)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getDescription()), 1),
          _hoisted_7,
          (_ctx.room)
            ? (_openBlock(), _createBlock(_component_RoomLightOverViewContent, {
                key: 0,
                room: _ctx.room,
                appo: _ctx.room.current_appointment
              }, null, 8, ["room", "appo"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("section", {
            class: "with_white_bg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)))
          }, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getButtonName()), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}